import React, { useEffect, useState } from "react";
import { Button, Form, message, Select } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../../utils/axiosInterceptor";
const { Option } = Select;

const InputPopUp = ({
  isVisible,
  onClose,
  selectedValue,
  getTargetData,
  month,
  year,
  pharmacy,
  name,
  value,
  email,
  currentVal,
  Quarter_GCR,
  Month_SGCR,
  Monthly_GPR,
  quarterGcrPer,
  monthSgcrPer,
  monthGprPer
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  useEffect(() => {
    if (isVisible) {
      form.setFieldsValue({
        Quarter_GCR: Quarter_GCR ? String(Quarter_GCR) : undefined,
        Month_SGCR:  Month_SGCR  ? String(Month_SGCR)  : undefined,
        Monthly_GPR: Monthly_GPR ? String(Monthly_GPR) : undefined,
      });
    }
  }, [isVisible, form, Quarter_GCR, Month_SGCR, Monthly_GPR]);

  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => { document.body.style.overflow = "auto"; };
  }, [isVisible]);

  if (!isVisible) return null;

   const generateOptions = () => {
    if (!quarterGcrPer) return [];

    return quarterGcrPer ?.filter(
    (item) =>
      item?.parameter === "Bx COGs" &&
      item?.lower_limit !== 0).map((item) => {
        const displayValue = item?.lower_limit;

        return (
          <Option key={item.lower_limit} value={displayValue}>
            {displayValue?.toFixed(2)} %
          </Option>
        );
      });
  };
    const generateOptionsForSGCR = () =>{
    if (!monthSgcrPer) return [];

    return monthSgcrPer?.filter(
    (item) =>item?.lower_limit !== 0
      )?.map((i) => {
        const displayValue = i?.lower_limit;

        return (
          <Option key={i?.lower_limit} value={displayValue}>
            {displayValue?.toFixed(2)} %
          </Option>
        );
      });
  };
    

const generateOptionsForGpr = () => {
  if (!monthGprPer) return [];

  const uniqueSortedData = [
    ...new Map(
      monthGprPer
        ?.filter((item) => item?.category === "Brand")
        ?.map((item) => [item?.lower_limit, item])
    ).values(),
  ];

  return uniqueSortedData.map((item) => {
    const displayValue =
      item?.lower_limit === 0
        ? item?.upper_limit
        : item?.lower_limit;

    return (
      <Option
        key={item?.lower_limit}
        value={displayValue} 
      >
        {Number(displayValue)?.toFixed(2)} %
      </Option>
    );
  });
};

  const handleSubmit = async (values) => {
    if (
      values?.Quarter_GCR === String(Quarter_GCR) &&
      values?.Month_SGCR  === String(Month_SGCR)  &&
      values?.Monthly_GPR === String(Monthly_GPR)
    ) {
      message.info("Please update your Target First");
      return;
    }
    const payload = {
      accounts:  pharmacy,
      userName:  name,
      targets: {
        Quarter_GCR: values?.Quarter_GCR,
        Month_SGCR:  values?.Month_SGCR,
        Month_GPR:   values?.Monthly_GPR,
      },
      month: Number(month),
      year:  year,
      email: email,
    };
    setIsLoading(true);
    try {
      const response = await axiosInstance.post("/api/v2/powerbi/targets", payload);
      message.success(response.data?.message);
      getTargetData();
    } catch (error) {
    } finally {
      setIsLoading(false);
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/50 backdrop-blur-sm">

      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 p-6 z-[1000]">

        <div
           style={{
             width: "100%",
             display: "flex",
             justifyContent: "end",
             marginBottom: 10,
           }}
         >
           <CloseOutlined className="flex justify-end" onClick={()=>{
             onClose();
           }} />
         </div>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          className="w-full"
        >

          <Form.Item
            name="Quarter_GCR"
            label={<span className="text-sm font-medium text-gray-700">Quarter GCR %</span>}
            rules={[
              { required: true, message: "Please select a value" },
            ]}
          >
            <Select
              placeholder="Select GCR %"
              size="large"
              className="w-full rounded-lg border border-gray-300"
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {generateOptions()}
            </Select>
          </Form.Item>

          <Form.Item
            name="Month_SGCR"
            label={<span className="text-sm font-medium text-gray-700">Monthly SGCR %</span>}
            rules={[
              { required: true, message: "Please select a value" },
            ]}
          >
            <Select
              placeholder="Select SGCR %"
              size="large"
              className="w-full rounded-lg border border-gray-300"
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {generateOptionsForSGCR()}
            </Select>
          </Form.Item>

          <Form.Item
            name="Monthly_GPR"
            label={<span className="text-sm font-medium text-gray-700">Monthly GPR %</span>}
            rules={[
              { required: true, message: "Please select a value" },
            ]}
          >
            <Select
              placeholder="Select GPR %"
              size="large"
              className="w-full rounded-lg border border-gray-300"
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {generateOptionsForGpr()}
            </Select>
          </Form.Item>

          <Form.Item className="mb-0">
             <Button
               type="primary"
               htmlType="submit"
               block
               size="large"
               className="custom-btn"
               loading={isLoading}
             >
               Submit
             </Button>
          </Form.Item>

        </Form>
      </div>
    </div>
  );
};

export default InputPopUp;

